"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBucketEndpointPlugin = exports.bucketEndpointMiddlewareOptions = exports.bucketEndpointMiddleware = void 0;

var tslib_1 = require("tslib");

var protocol_http_1 = require("@aws-sdk/protocol-http");

var bucketHostname_1 = require("./bucketHostname");

function bucketEndpointMiddleware(options) {
  var _this = this;

  return function (next) {
    return function (args) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var bucketName, replaceBucketInPath, request, _a, hostname, bucketEndpoint;

        return tslib_1.__generator(this, function (_b) {
          bucketName = args.input.Bucket;
          replaceBucketInPath = options.bucketEndpoint;
          request = args.request;

          if (protocol_http_1.HttpRequest.isInstance(request)) {
            if (options.bucketEndpoint) {
              request.hostname = bucketName;
            } else {
              _a = bucketHostname_1.bucketHostname({
                bucketName: bucketName,
                baseHostname: request.hostname,
                accelerateEndpoint: options.useAccelerateEndpoint,
                dualstackEndpoint: options.useDualstackEndpoint,
                pathStyleEndpoint: options.forcePathStyle,
                tlsCompatible: request.protocol === "https:"
              }), hostname = _a.hostname, bucketEndpoint = _a.bucketEndpoint;
              request.hostname = hostname;
              replaceBucketInPath = bucketEndpoint;
            }

            if (replaceBucketInPath) {
              request.path = request.path.replace(/^(\/)?[^\/]+/, "");

              if (request.path === "") {
                request.path = "/";
              }
            }
          }

          return [2
          /*return*/
          , next(tslib_1.__assign(tslib_1.__assign({}, args), {
            request: request
          }))];
        });
      });
    };
  };
}

exports.bucketEndpointMiddleware = bucketEndpointMiddleware;
exports.bucketEndpointMiddlewareOptions = {
  step: "build",
  tags: ["BUCKET_ENDPOINT"],
  name: "bucketEndpointMiddleware",
  relation: "before",
  toMiddleware: "hostHeaderMiddleware"
};

exports.getBucketEndpointPlugin = function (options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.addRelativeTo(bucketEndpointMiddleware(options), exports.bucketEndpointMiddlewareOptions);
    }
  };
};